const clone = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><polygon points="11 6 11 11 6 11 6 16 16 16 16 6"/><rect width="10" height="10"/></svg>',
};

export { clone as default };
